import React, { useContext } from "react";
import { Context } from "../index";
import { Button, ButtonProps } from "antd";

interface SendButtonProps extends ButtonProps {
  children: string;
}

export const SendButton: React.FC<SendButtonProps> = ({
  children,
  ...buttonProps
}) => {
  const { authStore, modalStore } = useContext(Context);

  const handleMessage = () => {
    if (authStore.isAuth) {
      modalStore.showMessageModal(true);
    } else {
      modalStore.showRedirectModal(true);
    }
  };
  return (
    <Button {...buttonProps} onClick={handleMessage}>
      {children}
    </Button>
  );
};
